module.exports = __webpack_public_path__ + "static/media/sydney-swans-logo.bd9dc5ba.svg";